import {combineReducers} from 'redux';
import {drf} from "./drfConnector";
import {selection} from "./selection";

export const cmsApp = combineReducers({
  selection,
  drf,
});


// WEBPACK FOOTER //
// ./src/reducers/index.js